<script setup lang="ts">
defineProps<{
  title?: string;
  subtitle?: string;
  /** Place the subtitle under the title instead of on its right. */
  stackedSubtitle?: boolean;
  /** Remove the boxed content and keep only the title above the content. */
  flat?: boolean;
  /** Draw a border around the content — for sections that are themselves the widget. */
  bordered?: boolean;
}>();

const ui = {
  section: "flex flex-col gap-3",
  header: "flex items-baseline justify-between gap-2",
  stackedHeader: "flex flex-col",
  title: "text-lg font-semibold text-secondary-900",
  subtitle: "text-sm text-secondary-700",
  flatContent: "flex flex-col",
  paddedContent: "flex flex-col gap-4",
  borderedContent: "flex flex-col gap-4 rounded-xl border border-secondary-200 bg-white p-4",
};
</script>

<template>
  <section :class="ui.section">
    <header v-if="title" :class="stackedSubtitle ? ui.stackedHeader : ui.header">
      <h2 :class="ui.title">{{ title }}</h2>
      <span v-if="subtitle" :class="ui.subtitle">{{ subtitle }}</span>
    </header>

    <div v-if="flat" :class="ui.flatContent">
      <slot></slot>
    </div>
    <div v-else-if="bordered" :class="ui.borderedContent">
      <slot></slot>
    </div>
    <div v-else :class="ui.paddedContent">
      <slot></slot>
    </div>
  </section>
</template>
